"use client";

import { usePathname, useRouter } from "@/i18n/navigation";
import { useParams } from "next/navigation";
import { routing } from "@/i18n/routing";
import { useLocale } from "next-intl";
import { Globe } from "lucide-react";

// https://next-intl.dev/docs/routing/navigation#userouter-change-locale
export default function LanguageSwitch({ className }: { className?: string }) {
  const pathname = usePathname();
  const router = useRouter();
  const locale = useLocale();
  const params = useParams();

  const alternateLocale = routing.locales.find((l) => l !== locale) || "en";

  function handleOnClick(e: React.MouseEvent) {
    e.preventDefault();
    router.replace(
      // @ts-expect-error -- TypeScript will validate that only known `params`
      // are used in combination with a given `pathname`. Since the two will
      // always match for the current route, we can skip runtime checks.
      { pathname, params },
      { locale: alternateLocale },
    );
  }
  return (
    <button
      onClick={handleOnClick}
      className={`shrink-0 cursor-pointer flex gap-1 justify-center items-center font-bold text-base py-3 px-3 rounded-lg bg-black/80 hover:bg-black text-white transition-all ease-in-out duration-300 ${className}`}
    >
      <Globe className="w-4 h-4" />
      <span>{alternateLocale.toUpperCase()}</span>
    </button>
  );
}
